angular.module("timeoutButton.components", []).component("timeoutButton", {
  templateUrl: "ng/components/timeoutButton/timeoutButton.view.html",
  bindings: {
    buttonTitle: "@",
    timeout: "<",
    callRest: "&",
    buttonId: "<?",
    cancelTimeout: "<",
  },
  controller: timeoutButtonController,
  controllerAs: "timeoutButtonCtrl",
});

function timeoutButtonController($interval, $scope) {
  var self = this;

  self.$onInit = function () {
    // self.count = self.timeout;
    // self.timerOn = true;
    // $timeout(function () {
    //   self.countdown();
    // }, 10);

    self.buttonDisabled = true;
    startTimer();
  };

  var startTimer = function () {
    self.timeRemaining = 600;
    var startTime = Date.now();
    self.intervalPromise = $interval(function () {
      var currentTime = Date.now();
      var elapsedTime = Math.floor((currentTime - startTime) / 1000);
      self.timeRemaining = 600 - elapsedTime;
      if (self.timeRemaining <= 0) {
        $interval.cancel(self.intervalPromise);
        self.timeRemaining = 0;
        self.buttonDisabled = false;
      }
    }, 1000);
  };

  self.callFunction = function () {
    // self.callRest && self.callRest();
    // self.countdown();
    // self.timerOn = true;
    self.callRest && self.callRest();
    self.buttonDisabled = true;
    startTimer();
  };

  $scope.$on("cancel-timer", function () {
    $interval.cancel(self.intervalPromise);
    self.timeRemaining = 0;
    self.buttonDisabled = false;
  });

  // self.countdown = function () {
  // if(!self.buttonId) {
  //   self.buttonId = 0;
  // }
  // self.circleVisible = self.timeout == self.count ? true : false;

  // self.timer = $interval(function () {
  //   self.timeout--;
  //   self.countdown();
  // }, 1000);

  // self.timer = $interval(
  //   function () {
  //     self.timeout = self.timeout - 10;
  //     self.countdown();
  //   },
  //   10000,
  //   1
  // );

  // var arc = document.getElementById("arc-" + self.buttonId);
  // if (!arc) {
  //   return;
  // }
  // if (self.timeout <= 0) {
  //   cancelTimer();
  // }
  // var angle = 360 * (self.timeout / self.count);
  // arc.setAttribute("d", describeArc(angle));
  // };

  // function getCoordinates(angleInDegrees) {
  //   var angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;
  //   var y = 100 + 100 * Math.sin(angleInRadians);
  //   var x = 100 + 100 * Math.cos(angleInRadians);
  //   return {
  //     x: x,
  //     y: y,
  //   };
  // }

  // function describeArc(angle) {
  //   var start = getCoordinates(angle);
  //   var end = getCoordinates(0);
  //   var largeArcFlag = angle - 0 <= 180 ? "0" : "1";

  //   var d = [
  //     "M",
  //     start.x,
  //     start.y,
  //     "A",
  //     100,
  //     100,
  //     0,
  //     largeArcFlag,
  //     0,
  //     end.x,
  //     end.y,
  //     "L",
  //     100,
  //     100,
  //     "L",
  //     start.x,
  //     start.y,
  //   ].join(" ");
  //   return d;
  // }
}
